import ActionType from '../actionTypes/saveDesignActionType';
import ApiEndpoints from '../ApiEndpoints';
import { handleRequest } from './helpers';
import { Dispatch } from 'redux';
import * as actions from './index';
import SnackBarType from '../../objects/app/snackbar';
import DesignsSimpleConverter from '../../converter/DesignsSimpleConverter';
import { IIndexable } from '../../components/GraphicsLibrary/GraphicDetail/GraphicDetail';
import { Selected } from '../../schemas/onlineDesigner';
import { IMember } from '../../components/TeamDialog/TeamDialog';

const saveDesign = (
    idProduct: number,
    idDesign: number,
    customerId: number | null,
    guestId: number | null,
    getDesignFceName: string,
    name: string | null,
    images: any,
    selectedData: Selected | null,
    teamData: IMember[] | null,
    addToCart: boolean = false,
    addProofService: boolean = false,
    saveAsNew: boolean = false,
    t: any = {}
) => async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
    const url = ApiEndpoints.PROCESS_DESIGN_SAVE_DESIGN(
        idProduct,
        idDesign,
        customerId,
        guestId
    );
    const actionTypes = ActionType.saveDesignWithImages;

    const data = {
        designJson: (window as IIndexable)[getDesignFceName](),
        imagesJson: images,
        selected: selectedData,
        team: teamData,
        name: name,
        addToCart,
        addProofService,
        saveAsNew,
    };

    return handleRequest(
        url,
        dispatch,
        actionTypes,
        (DesignRaw: any) => {
            return DesignsSimpleConverter.convertOne(DesignRaw);
        },
        'post',
        {},
        data,
        {},
        null,
        () => {
            dispatch(
                actions.addSnackbar(
                    t.saveDesignSuccess,
                    SnackBarType.SUCCESS,
                    false
                )
            );
            if (addToCart) {
                dispatch(
                    actions.addSnackbar(
                        t.addToCartSuccess,
                        SnackBarType.SUCCESS,
                        false
                    )
                );
            }
        }
    );
};

const saveDesignImages = (
    idProduct: number,
    idDesign: number,
    customerId: number | null,
    guestId: number | null,
    images: any,
    t: any = {}
) => async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
    const url = ApiEndpoints.PROCESS_DESIGN_SAVE_IMAGES(
        idProduct,
        idDesign,
        customerId,
        guestId
    );
    const actionTypes = ActionType.saveOnlyImages;

    const data = {
        imagesJson: images,
    };

    return handleRequest(
        url,
        dispatch,
        actionTypes,
        (DesignRaw: any) => {
            return DesignsSimpleConverter.convertOne(DesignRaw);
        },
        'post',
        {},
        data,
        {},
        null,
        () => {
            dispatch(
                actions.addSnackbar(
                    t.saveDesignImagesSuccess,
                    SnackBarType.SUCCESS,
                    false
                )
            );
        }
    );
};

const saveDesignName = (
    idDesign: number,
    customerId: number | null,
    guestId: number | null,
    name: string,
    t: any = {}
) => async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
    const url = ApiEndpoints.PROCESS_DESIGN_SAVE_NAME(
        idDesign,
        customerId,
        guestId
    );
    const actionTypes = ActionType.saveDesignName;

    const data = {
        name: name,
    };

    return handleRequest(
        url,
        dispatch,
        actionTypes,
        null,
        'post',
        {},
        data,
        {},
        null,
        () => {
            dispatch(
                actions.addSnackbar(
                    t.saveDesignNameSuccess,
                    SnackBarType.SUCCESS,
                    false
                )
            );
        }
    );
};

const saveDesignReset = () => ({
    type: ActionType.saveDesignWithImages.reset,
});

const saveDesignImagesReset = () => ({
    type: ActionType.saveOnlyImages.reset,
});

const saveDesignNameReset = () => ({
    type: ActionType.saveDesignName.reset,
});

export {
    saveDesign,
    saveDesignImages,
    saveDesignReset,
    saveDesignImagesReset,
    saveDesignName,
    saveDesignNameReset,
};
